export { default as ErrorPage } from './ErrorPage';
export { default as SessionExpiredPage } from './SessionExpiredPage';
export { default as MaintenancePage } from './MaintenancePage';
export { default as RegisteredPage } from './RegisteredPage';
export { default as PDCORegistrationSuccessPage } from "./PDCORegistrationSuccessPage";